import { useMutation, useQuery } from "@tanstack/react-query";
import { masterPeriodApiService } from "./periodmodule.api";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statuscode: number;
}

export const useMasterPeriodService = (
  searchText?: string | null,
  id?: number,
  pageNumber: number = 1,
  pageSize: number = 10,
) => {
  const SelectAllQuery = useQuery({
    queryKey: ["master-period-selectAll", searchText, pageNumber, pageSize],
    queryFn: () =>
      masterPeriodApiService.getSelectAllData(searchText, pageNumber, pageSize),
    enabled: !!pageNumber && !!pageSize,
  });

  const SelectQuery = useQuery({
    queryKey: ["master-period-select", id],
    queryFn: () => masterPeriodApiService.getSelectData(id!),
    enabled: !!id,
  });

  const InsertMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => masterPeriodApiService.insertData(payload),
  });

  const UpdateMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => masterPeriodApiService.updateData(payload),
  });

  const DeleteMutation = useMutation<
    ApiResponse,
    Error,
    { masterperiodid: number; updatereason: string }
  >({
    mutationFn: (payload) =>
      masterPeriodApiService.deleteData({
        masterperiodid: payload.masterperiodid,
        updatereason: payload.updatereason,
      }),
  });

  return {
    SelectAllQuery,
    SelectQuery,
    InsertMutation,
    UpdateMutation,
    DeleteMutation,
  };
};
